/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
import { DeviceHealthIssueCategory } from '../../models';
import { DeviceHealthActions, EDeviceHealthAction } from '../actions/device-health.actions';
import { IDeviceHealth, IDeviceHealthState, initialDeviceHealthState } from '../state/device-health.state';

export function deviceHealthReducer(state = initialDeviceHealthState, action: DeviceHealthActions): IDeviceHealthState {
  switch (action.type) {
    case EDeviceHealthAction.GetSelectedDeviceHealthStatus: {
      return {
        ...state,
        devices: [...state.devices],
        devicesHealthLoading: true
      };
    }
    case EDeviceHealthAction.GetAllDeviceHealthStatusSuccess: {
      return {
        ...state,
        devices: action.devicesHealth.filter(
          (device: IDeviceHealth) => device.healthStatus.toUpperCase() != DeviceHealthIssueCategory.Optimal
        ),
        devicesHealthLoading: false,
        totalDeviceIssues: action.countOfDevicesError ?? 0
      };
    }
    case EDeviceHealthAction.GetSelectedDeviceHealthStatusError: {
      return {
        ...state,
        devices: [...state.devices],
        devicesHealthLoading: false
      };
    }
    case EDeviceHealthAction.SelectVehicleIdForDeviceHealthSuccess: {
      return {
        ...state,
        selectedVehicleId: action.vehicleId
      };
    }
    case EDeviceHealthAction.GetSelectedDeviceHealthStatusSuccess: {
      return {
        ...state,
        devices: _appendDevices(
          state.devices,
          action.devicesHealth.filter((device: IDeviceHealth) => device.healthStatus != DeviceHealthIssueCategory.Optimal)
        )
      };
    }
    case EDeviceHealthAction.GetCountOfAllDeviceIssuesError: {
      return {
        ...state,
        totalDeviceIssues: state.totalDeviceIssues ?? 0
      };
    }
    default:
      return state;
  }

  function _appendDevices(existingDevices: IDeviceHealth[], appendDevices: IDeviceHealth[]): IDeviceHealth[] {
    appendDevices.forEach(x => {
      if (!existingDevices.find(e => e.vehicleId == x.vehicleId)) {
        existingDevices.push(x);
      }
    });

    return existingDevices;
  }
}
